export default [
  {
    path: 'masters',
    name: 'masters',
    redirect: { name: 'masters/society' }
  },
  {
    path: 'masters/society/:id/details',
    name: 'masters/society/details',
    component: () => import('@/views/configuration/Contact.vue'),
    meta: { secondaryMenu: 'masters/society', registerNavFromMenu: false }
  },
  {
    path: 'masters/society',
    name: 'masters/society',
    component: () => import('@/views/configuration/Sociedades.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'masters/society/:id/locations',
    name: 'masters/society/locations',
    component: () => import('@/views/configuration/Sedes.vue'),
    meta: { secondaryMenu: 'masters/society', registerNavFromMenu: false }
  },
  {
    path: 'masters/society/:id/linkedcompanies',
    name: 'masters/society/linkedcompanies',
    component: () => import('@/views/configuration/SedesLinkedCompanies.vue'),
    meta: { secondaryMenu: 'masters/society', registerNavFromMenu: false }
  },
  {
    path: 'masters/society/:id/locations/:idSede/details',
    name: 'masters/society/locations/details',
    component: () => import('@/views/configuration/Sede.vue'),
    meta: { secondaryMenu: 'masters/locations', registerNavFromMenu: false }
  },
  {
    path: 'masters/society/:id/locations/:idSede/contactemails',
    name: 'masters/society/locations/contactemails',
    component: () => import('@/views/configuration/ContactEmail.vue'),
    meta: { secondaryMenu: 'masters/locations', registerNavFromMenu: false }
  },
  {
    path: 'masters/society/:id/locations/:idSede/bankaccounts',
    name: 'masters/society/locations/bankaccounts',
    component: () => import('@/views/configuration/BankAccounts.vue'),
    meta: { secondaryMenu: 'masters/locations', registerNavFromMenu: false }
  },
  {
    path: 'masters/society/:id/locations/:idSede/bankaccounts/:idCuenta/details',
    name: 'masters/society/locations/bankaccounts/details',
    component: () => import('@/views/configuration/BankAccount.vue'),
    meta: { secondaryMenu: 'masters/society/locations/bankaccounts', registerNavFromMenu: false }
  },
  {
    path: 'masters/society/:id/locations/:idSede/administrativecenters',
    name: 'masters/society/locations/administrativecenters',
    component: () => import('@/views/configuration/AdministrativeCentersHandler.vue'),
    meta: { secondaryMenu: 'masters/locations', registerNavFromMenu: false }
  },
  {
    path: 'masters/society/:id/locations/:idSede/administrativecenters/:idCentro/details',
    name: 'masters/society/locations/administrativecenters/details',
    component: () => import('@/views/configuration/AdministrativeCenterHandler.vue'),
    meta: { secondaryMenu: 'masters/administrativecenters', registerNavFromMenu: false }
  },
  {
    path: 'masters/society/:id/usersproviders',
    name: 'masters/society/usersproviders',
    component: () => import('@/views/configuration/UserProviderByContact.vue'),
    meta: { secondaryMenu: 'masters/society', registerNavFromMenu: false }
  },
  {
    path: 'masters/society/:id/historical',
    name: 'masters/society/historical',
    component: () => import('@/views/historical/ContactHistorical.vue'),
    meta: { secondaryMenu: 'masters/society', registerNavFromMenu: false }
  },
  {
    path: 'trash/society',
    name: 'trash/society',
    component: () => import('@/views/trash/Sociedades.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'trash/society/:id/details',
    name: 'trash/society/details',
    component: () => import('@/views/trash/Contact.vue'),
    meta: { secondaryMenu: 'configurations/trash/society', registerNavFromMenu: false }
  },
  {
    path: 'trash/society/:id/historical',
    name: 'trash/society/historical',
    component: () => import('@/views/historical/TrashContactHistorical.vue'),
    meta: { secondaryMenu: 'configurations/trash/society', registerNavFromMenu: false }
  },
  {
    path: 'masters/impuestos/:id/historical',
    name: 'masters/impuestos/historical',
    component: () => import('@/views/historical/ImpuestoHistorical.vue'),
    meta: { secondaryMenu: 'masters/impuestos', registerNavFromMenu: false }
  },
  {
    path: 'masters/impuestos/:id/details',
    name: 'masters/impuestos/details',
    component: () => import('@/views/configuration/Impuesto.vue'),
    meta: { secondaryMenu: 'masters/impuestos', registerNavFromMenu: false }
  },
  {
    path: 'masters/impuestos',
    name: 'masters/impuestos',
    component: () => import('@/views/configuration/Impuestos.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'masters/products/:id/impuestos',
    name: 'masters/products/impuestos',
    component: () => import('@/views/configuration/ProductsImpuestos.vue'),
    meta: { secondaryMenu: 'masters/products', registerNavFromMenu: false }
  },
  {
    path: 'trash/impuestos/:id/details',
    name: 'trash/impuestos/details',
    component: () => import('@/views/trash/Impuesto.vue'),
    meta: { secondaryMenu: 'configurations/trash/impuestos', registerNavFromMenu: false }
  },
  {
    path: 'trash/impuestos/:id/historical',
    name: 'trash/impuestos/historical',
    component: () => import('@/views/historical/TrashImpuestoHistorical.vue'),
    meta: { secondaryMenu: 'configurations/trash/impuestos', registerNavFromMenu: false }
  },
  {
    path: 'trash/impuestos',
    name: 'trash/impuestos',
    component: () => import('@/views/trash/Impuestos.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'masters/products/:id/historical',
    name: 'masters/products/historical',
    component: () => import('@/views/historical/ProductsHistorical.vue'),
    meta: { secondaryMenu: 'masters/products', registerNavFromMenu: false }
  },
  {
    path: 'masters/products/:id/details',
    name: 'masters/products/details',
    component: () => import('@/views/configuration/Product.vue'),
    meta: { secondaryMenu: 'masters/products', registerNavFromMenu: false }
  },
  {
    path: 'masters/products',
    name: 'masters/products',
    component: () => import('@/views/configuration/Products.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'trash/products/:id/details',
    name: 'trash/products/details',
    component: () => import('@/views/trash/Product.vue'),
    meta: { secondaryMenu: 'configurations/trash/products', registerNavFromMenu: false }
  },
  {
    path: 'trash/products/:id/historical',
    name: 'trash/products/historical',
    component: () => import('@/views/historical/TrashProductHistorical.vue'),
    meta: { secondaryMenu: 'configurations/trash/products', registerNavFromMenu: false }
  },
  {
    path: 'trash/products',
    name: 'trash/products',
    component: () => import('@/views/trash/Products.vue'),
    meta: { registerNavFromMenu: false }
  },
]
